import React from  'react';
import './head.css';


export const Head = () => {
  return (
    <div className="head">期货仓位计算小工具</div>
  )
}